<template>
  <div>
    <!-- DIALOG DE RECORDATORIO -->
    <v-dialog v-model="recordatorioDialog" max-width="550">
      <v-card class="py-3">
        <v-card-title class="headline">
          <span> ℹ️ Información </span>
          <v-spacer></v-spacer>
          <v-btn icon color="red" small @click="recordatorioDialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="subtitle-1">
          <b>Importante:</b> Asegúrate de <b>Iniciar Sesión</b> en el
          <b>Social</b>, <b>WhatsApp</b> Y <b>PBX</b> antes de seleccionar tu
          extensión.
        </v-card-text>
        <v-card-text class="subtitle-1 text-right">
          <b>¡Esto garantizará que recibas todas las alertas!</b>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="internalVisible" persistent max-width="400px">
      <v-snackbar
        v-model="snackState"
        :color="snackColor"
        :timeout="snackTime"
        bottom
        right
      >
        {{ snackText }}
      </v-snackbar>

      <!-- Dialog: CONFIRMAR ACCION -->
      <v-dialog v-model="confirmDialog" max-width="350">
        <v-card class="py-3">
          <v-card-title class="headline"> ¿Desea continuar? </v-card-title>
          <v-card-text class="subtitle-1">
            Esta acción creará un nuevo turno con la extensión
            <span class="font-weight-medium">"{{ getExtensionName }}"</span>.
          </v-card-text>
          <v-card-actions class="px-6">
            <v-btn color="primary" outlined @click="confirmDialog = false">
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="asignarExtension"> Continuar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card class="py-5 px-4 text-center">
        <v-card-title class="headline pt-4 flex-column">
          <v-flex> Bienvenido/a!</v-flex>
          <v-flex class="subtitle-2"> {{ userInfo.nombre }} </v-flex>
        </v-card-title>
        <v-divider class="mx-6"></v-divider>
        <v-card-text class="pt-4 py-2"
          >Por favor, selecciona una extensión:</v-card-text
        >
        <v-card-text class="pb-0">
          <v-autocomplete
            v-model="extensionDisponibleId"
            :loading="loadExtensiones"
            :items="extensionesDisponibles"
            @click="listarExtensionesDisponibles"
            item-value="extensionId"
            :filter="extensionFilter"
            item-text="nombre"
            label="Extensiones"
            clearable
          >
            <template v-slot:selection="data">
              <p class="ma-0 font-weight-medium">
                {{ data.item.extension }} -
                <span>
                  {{ data.item.nombre }}
                </span>
              </p>
            </template>
            <template v-slot:item="data">
              <p class="ma-0 font-weight-medium">
                {{ data.item.extension }} -
                <span>
                  {{ data.item.nombre }}
                </span>
              </p>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn
            block
            color="primary"
            @click="confirmDialog = true"
            :disabled="!extensionDisponibleId"
            >Seleccionar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import decode from "jwt-decode";

export default {
  name: "AsignarExtension",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    token: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recordatorioDialog: true,
      confirmDialog: false,
      snackState: false,
      snackText: "",
      snackColor: "primary",
      snackTime: 3500,
      userInfo: {},
      extensionId: null,
      loadExtensiones: false,
      extensiones: [],
      extensionDisponibleId: null,
      extensionesDisponibles: [],
      internalVisible: this.visible,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.listarExtensiones();
        this.decodeToken();
        this.listarExtensionesDisponibles();
      }
      this.internalVisible = val;
    },
  },
  computed: {
    getExtensionName() {
      if (this.extensionDisponibleId == null) return "";
      const extension = this.extensionesDisponibles.filter(
        (ext) => ext.extensionId == this.extensionDisponibleId
      );

      if (extension.length == 0) return "";

      return `${extension[0].extension} - ${extension[0].nombre}`;
    },
  },
  created() {},
  methods: {
    extensionFilter(item, queryText, itemText) {
      return (
        item.extension
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.nombre.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },
    listarExtensiones() {
      let header = { Authorization: "Bearer " + this.$props.token };
      let configuracion = { headers: header };

      axios
        .get("api/Extensiones", configuracion)
        .then((res) => (this.extensiones = res.data))
        .catch((err) => console.log(err));
    },
    listarExtensionesDisponibles() {
      this.extensionDisponibleId = null;
      this.loadExtensiones = true;

      let header = { Authorization: "Bearer " + this.$props.token };
      let configuracion = { headers: header };

      axios
        .get("api/Extensiones/Disponibles", configuracion)
        .then((res) => (this.extensionesDisponibles = res.data))
        .catch((res) => console.log(res.data))
        .finally(() => (this.loadExtensiones = false));
    },
    decodeToken() {
      this.userInfo = decode(this.token);
    },
    asignarExtension() {
      this.decodeToken();

      let header = { Authorization: "Bearer " + this.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/HistorialOperadoresCabina",
          {
            usuarioId: this.userInfo.idUsuario,
            extensionId: this.extensionDisponibleId,
          },
          configuracion
        )
        .then((res) => {
          this.$store.dispatch("guardarToken", this.token);
          this.$router.push({ name: "novedades" });

          this.snackText = "¡Extensión seleccionada!";
          this.snackColor = "primary";
          this.snackTime = 2000;
          this.snackState = true;
        })
        .catch((err) => {
          const error = err.response.data;

          this.snackText = "No se pudo crear el Turno.";

          if (error && error.includes("activo")) {
            this.snackText =
              "Ya tienes un turno creado. Por favor, cierra tu turno anterior antes de crear uno nuevo.";
          }

          this.snackColor = "red";
          this.snackTime = 6000;
          this.snackState = true;

          this.confirmDialog = false;
          this.listarExtensionesDisponibles();

          console.error(err);
        });
    },
  },
};
</script>
